import { useAppDispatch, useAppSelector, useAppStore } from 'app/hooks';
import { applyDuctedTonnageSeed } from 'features/ui';
import { tonnageSeedKeyOf } from 'features/ui/tonnage-filter-seed';
import useIsCompatibilityPathway from 'hooks/use-is-compatibility-pathway';
import { useEffect } from 'react';
import { resolveStructureTonnageSeed } from 'utils/tonnage-seed-state';

export default function useTonnageFilterSeed() {
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const isDucted = useIsCompatibilityPathway();
  const seedKey = useAppSelector((state) =>
    tonnageSeedKeyOf(resolveStructureTonnageSeed(state))
  );
  const appliedSeedKey = useAppSelector(
    (state) => state.ui.ductedFilters.tonnageSeedKey
  );

  useEffect(() => {
    if (!isDucted) return;
    if (seedKey === null) {
      if (appliedSeedKey !== null) dispatch(applyDuctedTonnageSeed(null));
      return;
    }
    if (appliedSeedKey === seedKey) return;
    dispatch(
      applyDuctedTonnageSeed(resolveStructureTonnageSeed(store.getState()))
    );
  }, [isDucted, seedKey, appliedSeedKey, dispatch, store]);
}
